import App from '@/App';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { createRoot } from 'react-dom/client';

// Initialise Posthog with cookieless tracking
// Uses privacy-preserving hash for users who opt out of cookies
const servicePaused = import.meta.env.VITE_SERVICE_PAUSED === 'true';

if (!servicePaused && import.meta.env.VITE_APP_ENV !== 'development') {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    cookieless_mode: 'on_reject', // Use cookieless tracking when user rejects cookies
    persistence: 'localStorage',
  });

  window.posthog = posthog;

  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^https:\/\/api\.loveinvoice\.com\/.*/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      enableLogs: true,
    });
  }
}

createRoot(document.getElementById('root')).render(<App />);
